import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import type { CommunityEssentialFolderModel } from '@/models'
import { resetQueries } from '@/utils/api/reset-queries'

import { GET_ALL_FOLDERS_BASE_QUERY_KEY } from './get-all-folders'
import { GET_FOLDER_CONTENT_BASE_QUERY_KEY } from './get-folder-content'

export interface CreateFolderRequest {
  buildingId: number
  name: string
  parentFolderId?: number | null
  position?: number
}

export const createFolder = async (data: CreateFolderRequest) => {
  const { buildingId, ...body } = data
  const response = await authAPI.post<CommunityEssentialFolderModel[]>(
    `/building-essential/${buildingId}/folder`,
    body,
  )
  return response.data
}

export const useCreateFolder = () => {
  return useMutation({
    mutationFn: createFolder,
    onSuccess: () =>
      resetQueries([GET_FOLDER_CONTENT_BASE_QUERY_KEY], [GET_ALL_FOLDERS_BASE_QUERY_KEY]),
  })
}
